<neo-expansion-panel
  class="cm-expansion-panel"
  [expanded]="expanded()"
  [disabled]="disabled()"
  (expandedChange)="expandedChange.emit($event)"
>
  <neo-expansion-panel-header>
    <!-- If custom header content is provided, use it -->
    <ng-content select="[cmExpansionPanelHeader]" />

    <!-- Otherwise, use title and description inputs -->
    @if (title()) {
      <neo-panel-title>{{ title() }}</neo-panel-title>
    }
    @if (description()) {
      <neo-panel-description>{{ description() }}</neo-panel-description>
    }
  </neo-expansion-panel-header>

  <!-- Main content -->
  <ng-content />
</neo-expansion-panel>
